module.exports = __webpack_public_path__ + "static/media/esim_graph2_chz.e75ad063.png";